// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","social":"Footer_social__MfQNF","copy":"Footer_copy__NeIYV"};